module.exports = __webpack_public_path__ + "src/routes/aboutus/brand.png?9f2bc4c0";


//////////////////
// WEBPACK FOOTER
// ./src/routes/aboutus/brand.png
// module id = 2830
// module chunks = 1